// src/components/Admin/PostManager/CreatePostPointSetting.jsx
import { useEffect, useState } from 'react';
import { Box, TextField, Button, Stack } from '@mui/material';
import api from '../../../api/axios';

export default function CreatePostPointSetting() {
    const [policy, setPolicy] = useState(null);   // { id, action, amount }
    const [loading, setLoading] = useState(true);

    /* 정책 1개 가져오기 */
    useEffect(() => {
        api
            .get('/api/point-policy/?action=create_post')
            .then(res => {
                // 항상 하나만 있다고 가정
                if (res.data?.length) setPolicy(res.data[0]);
            })
            .catch(() => alert('포인트 정책 불러오기 실패'))
            .finally(() => setLoading(false));
    }, []);

    /* 저장 */
    const handleSave = () => {
        if (!policy) return alert('정책을 불러오지 못했습니다.');

        api
            .put(`/api/point-policy/${policy.id}/`, {
                action: policy.action,      // ← serializer가 요구
                amount: policy.amount,
            })
            .then(() => alert('포인트 정책이 저장되었습니다.'))
            .catch(() => alert('저장 실패'));
    };

    if (loading || !policy) return null;

    return (
        <Box sx={{ p: 2 }}>

            <Stack direction="row" spacing={2} sx={{ mt: 2, alignItems: 'center' }}>
                <TextField
                    label="지급 Leaf"
                    type="number"
                    value={policy.amount}
                    onChange={e =>
                        setPolicy(prev => ({ ...prev, amount: Number(e.target.value) }))
                    }
                    inputProps={{ min: 0 }}
                    sx={{ width: 120 }}
                />
                <Button variant="contained" onClick={handleSave}>
                    저장
                </Button>
            </Stack>
        </Box>
    );
}
